<div class="d-flex flex-column export-section">

  <div class="flex-body p-0-20 relative export-section-container">
    @if (!showLoader) {
      <div class="flex-body-content">
        <div class="row  align-items-center export-head">
          <div class="col-6 p-l-0">
            <b class="text-lg">Export</b>
          </div>
          <div class="col-6 d-flex align-items-center justify-content-end p-r-0">
            <label class="tabs" [ngClass]="{'active':(selectedTab == 'download')}" (click)="onTabSelect('download')">Download</label>
            @if (data.fromPlant) {
              <label class="tabs" [ngClass]="{'active':(selectedTab == 'webpage')}"
                (click)="onTabSelect('webpage')"
                >Share as
              Webpage</label>
            }
          </div>
        </div>
        @if (selectedTab == 'download') {
          <div class="row p-t-20 widgets-container">
            <div class="col-6">
              <label class="label-text">Select file type</label>
              <ul class="list-none export-radio-group m-t-10 d-flex flex-column">
                @for (option  of exportOptions; track option ; let i = $index) {
                  <li class="export-radio-button">
                    <label>
                      <input type="radio" name="type" (ngModelChange)="onOptionChange($event)"
                        [(ngModel)]="selectedOption" [value]="option?.type" id="{{'radio-'+ i}}" />
                      <span class="radiobtn"></span>
                      <span class="option-name">
                        {{option?.name}}
                      </span>
                    </label>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
        @if (selectedTab == 'webpage') {
          <div class="p-t-20 widgets-container">
            <div class="row align-items-center w-100 p-b-16">
              <div class="col-12 p-r-0 p-l-0 label-text">
                <label>Shareable Webpage</label><br />
              </div>
              <div class="col-3 p-r-0 p-l-0 d-flex align-items-center">
                <mat-slide-toggle disableRipple=true
                  [(ngModel)]="sharableWebpage"
                  (change)="onWebpageChange($event)">
                  </mat-slide-toggle> <span class="toggle-label-txt">ON</span>
                </div>
                @if (!isLoading) {
                  @if (sharableWebpage) {
                    <div class="col-9 d-flex align-items-center justify-content-end p-r-0" style="font-size: 13px;"
                      >
                      <button class="btn btn-text color-primary text-uppercase p-t-0 p-b-0 preview-btn" (click)="generateShareLink()">Generate
                      new Link</button>
                      <button class="btn btn-text color-primary text-uppercase share p-t-0 p-b-0 preview-btn">
                        <a target="_blank" href={{link}}>Preview Webpage</a>
                      </button>
                    </div>
                  }
                } @else {
                  @if (isLoading) {
                    <div class="d-flex align-items-center justify-content-center">
                      <img src="./assets/images/loader.gif" width="36" />
                    </div>
                  }
                }
              </div>
              @if (sharableWebpage && !isLoading) {
                <div class="col-12 p-l-0 p-r-0 m-t-10 share-link">
                  <label class="lbl label-text" (click)="copyLink()">Link - <small>Click to copy</small>
                  @if (linkCopiedToClipboard) {
                    <span class="copied">Copied to Clipboard</span>
                  }
                </label>
                <mat-form-field class="d-block  p-l-10" [floatLabel]="'never'">
                  <input matInput type="text" [(ngModel)]="link" (click)="copyLink()" />
                  <i matPrefix class="fas fa-copy color-primary p-r-5" aria-hidden="true"
                  (click)="copyLink()"></i>
                </mat-form-field>
              </div>
              <div class="col-12 p-l-0 p-r-0 m-t-10 share-link">
                <label class="lbl label-text" (click)="copyEmbedText()">Embed - <small>Click to copy</small>
                @if (embedCopiedToClipboard) {
                  <span class="copied">Copied to Clipboard</span>
                }
              </label>
              <mat-form-field class="d-block  p-l-10" [floatLabel]="'never'">
                <input matInput type="text" [(ngModel)]="embedLink" (click)="copyEmbedText()" />
                <i matPrefix class="fas fa-copy color-primary p-r-5" aria-hidden="true"
                (click)="copyEmbedText()"></i>
              </mat-form-field>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (showLoader) {
    <div class="d-flex align-items-center justify-content-center fixedLoader">
      <img src="./assets/images/loader.gif" alt="" width="64"/>
    </div>
  }
</div>
@if (!showLoader) {
  <div class="flex-footer d-flex justify-content-end align-items-center">
    <button class="btn btn-outline-primary color-primary text-uppercase" (click)="onNoClick()">{{selectedTab == 'download'? 'Cancel' : 'Close'}}</button>
    @if (selectedTab == 'download') {
      <button class="btn btn-outline-primary color-primary text-uppercase" [disabled]="showLoader" (click)="download()">Download</button>
    }
  </div>
}
</div>